import { render, staticRenderFns } from "./GoodsPicker.vue?vue&type=template&id=2fe819ee&scoped=true"
import script from "./GoodsPicker.vue?vue&type=script&lang=js"
export * from "./GoodsPicker.vue?vue&type=script&lang=js"
import style0 from "./GoodsPicker.vue?vue&type=style&index=0&id=2fe819ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe819ee",
  null
  
)

export default component.exports